module.exports = __webpack_public_path__ + "static/blue2-dbea2419481d70d7ddef4ecf1ecdcc55.png";